import React from "react";
import { Button, Checkbox, Empty, InputNumber, Select } from "antd";
import "./DiamondCards.css";
import { FaCartPlus, FaCheck, FaTrashAlt } from "react-icons/fa";

const DiamondCards = ({
  dataList,
  handleSave,
  setDataList,
  showDiscount,
  cartValue,
  isCart,
  handleRemove,
  toggleCheckList,
  isItemInList,
  checkList,
  setListCheck,
  handleRemoveFromCart,
}) => {
  return (
    <div className="diamond-cards-container">
      {dataList && dataList.length > 0 ? (
        dataList?.map((v, i) => (
          <div key={i} className="diamond-card">
            <div className="row mb-1">
              <div className="col-12">
                {isCart ? (
                  <Checkbox
                    checked={checkList.some((val) => val === v.cart_id)}
                    onChange={() =>
                      setListCheck(
                        (prev) =>
                          prev.some((value) => value === v.cart_id)
                            ? prev.filter((value) => value !== v.cart_id) // Remove if exists
                            : [...prev, v.cart_id] // Add if doesn't exist
                      )
                    }
                  >
                    Check This
                  </Checkbox>
                ) : (
                  <Checkbox
                    checked={
                      isItemInList(cartValue, v) || isItemInList(checkList, v)
                    }
                    onChange={() => toggleCheckList(v)}
                    disabled={isItemInList(cartValue, v)}
                  >
                    Check This
                  </Checkbox>
                )}
              </div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Size(MM)</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.diam_mm}</div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Avg Weight</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.avg_wt}</div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Color</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.type}</div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Shade</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.shade}</div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Cut</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.cut}</div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Clarity</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.priceType}</div>
            </div>
            <div className="row mb-1">
              <div className="col-6">
                <strong>Price</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">$ {v.price}</div>
            </div>
            {showDiscount && (
              <div className="row mb-1">
                <div className="col-6">
                  <strong>Discount</strong>
                </div>
                <div className="col-2">-</div>
                <div className="col-4">
                  {isCart ? (
                    "$ " + v.discount
                  ) : (
                    <InputNumber
                      prefix="$"
                      max={25}
                      value={v.discount}
                      onChange={(val) =>
                        setDataList((prev) => {
                          const updatedDataList = [...prev];
                          updatedDataList[i] = {
                            ...updatedDataList[i],
                            discount: val,
                            updatedPrice: parseFloat(v.mainPrice - val).toFixed(
                              2
                            ),
                          };
                          return updatedDataList;
                        })
                      }
                    />
                  )}
                </div>
              </div>
            )}
            <div className="row mb-1">
              <div className="col-6">
                <strong>Type</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">
                <Select
                  style={{ width: "100%", maxWidth: "100px" }}
                  placeholder="Type"
                  onSelect={(val) =>
                    setDataList((prev) => {
                      const updatedDataList = [...prev];
                      updatedDataList[i] = {
                        ...updatedDataList[i],
                        typeSelect: val,
                        total_weight: parseFloat(
                          val === "Carat"
                            ? updatedDataList[i].caratValue
                            : updatedDataList[i].updatePice *
                                updatedDataList[i].avg_wt
                        ).toFixed(2),
                        updatedPrice:
                          val === "Carat"
                            ? parseFloat(
                                updatedDataList[i].updateCarat *
                                  updatedDataList[i].price
                              ).toFixed(2)
                            : (
                                parseFloat(
                                  updatedDataList[i].avg_wt *
                                    updatedDataList[i].updatePice
                                ) * updatedDataList[i].price
                              ).toFixed(2),
                      };
                      return updatedDataList;
                    })
                  }
                  value={v.typeSelect}
                >
                  <Select.Option value="Carat">Carat</Select.Option>
                  <Select.Option value="Piece">Piece</Select.Option>
                </Select>
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-6">
                <strong>Selected Type </strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">
                {v.typeSelect === "Carat" ? (
                  <>
                    <InputNumber
                      style={{
                        minHeight: 33,
                        maxWidth: "100px",
                        borderColor:
                          parseFloat(v.updateCarat) > 10 ? "red" : "#afafaf",
                      }}
                      value={v.updateCarat}
                      step={0.001}
                      onChange={(val) =>
                        setDataList((prev) => {
                          const updatedDataList = [...prev];
                          updatedDataList[i] = {
                            ...updatedDataList[i],
                            updateCarat: val,
                            total_weight: parseFloat(val).toFixed(2),
                            updatedPrice: (parseFloat(val) * v.price)
                              // +
                              // (updatedDataList[i].cut === "Excellent" ? 15 : 0)
                              .toFixed(2),
                          };
                          return updatedDataList;
                        })
                      }
                    />
                    <br />
                    {parseFloat(v.updateCarat) > 10 && (
                      <span
                        style={{
                          color: "red",
                          fontSize: ".75rem",
                        }}
                      >
                        Max 10 Carat
                      </span>
                    )}
                  </>
                ) : (
                  <InputNumber
                    style={{ minHeight: 33, maxWidth: "100px" }}
                    value={v.updatePice}
                    step={1}
                    onChange={(valu) =>
                      setDataList((prev) => {
                        const updatedDataList = [...prev];
                        updatedDataList[i] = {
                          ...updatedDataList[i],
                          updatePice: valu,
                          total_weight: parseFloat(valu * v.avg_wt).toFixed(2),
                          updatedPrice: (valu * v.avg_wt * v.price)
                            // +
                            // (updatedDataList[i].cut === "Excellent" ? 15 : 0)
                            .toFixed(2),
                        };
                        return updatedDataList;
                      })
                    }
                  />
                )}
              </div>
            </div>

            <div className="row mb-1">
              <div className="col-6">
                <strong>Total Weight</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">{v.total_weight}</div>
            </div>

            <div className="row mb-1">
              <div className="col-6">
                <strong>Subtotal</strong>
              </div>
              <div className="col-2">-</div>
              <div className="col-4">$ {v.updatedPrice}</div>
            </div>
            <div className="diamond-card-row mt-3">
              {isCart ? (
                <Button
                  className="bg-danger text-white w-100"
                  type="link"
                  onClick={() => handleRemove(i)}
                >
                  <FaTrashAlt className="orderFilter-add-to-cart-btn-icon" />{" "}
                  Remove from cart
                </Button>
              ) : cartValue.some(
                  (valueCheck) =>
                    valueCheck.product_id === v.product_id &&
                    valueCheck.sive_sizes === v.sive_sizes &&
                    valueCheck.diam_mm === v.diam_mm &&
                    valueCheck.avg_wt === v.avg_wt &&
                    valueCheck.color === v.color &&
                    valueCheck.shade === v.shade &&
                    valueCheck.cut === v.cut &&
                    valueCheck.clarity === v.clarity &&
                    valueCheck.typeSelect === v.typeSelect &&
                    (valueCheck.updateCarat === v.updateCarat ||
                      valueCheck.updatePice === v.updatePice)
                ) ? (
                <div className="d-flex align-items-center">
                  <Button
                    className="w-100 text-white bg-success"
                    type="link"
                    style={{ backgroundColor: "green" }}
                  >
                    <FaCheck className="orderFilter-add-to-cart-btn-icon " />{" "}
                    Added into cart
                  </Button>
                  {handleRemoveFromCart && (
                    <Button
                      className="w-100 bg-danger text-white"
                      type="link"
                      style={{ marginLeft: "10px" }}
                      onClick={() =>
                        handleRemoveFromCart(
                          cartValue.map((valueCheck) =>
                            valueCheck.product_id === v.product_id &&
                            valueCheck.sive_sizes === v.sive_sizes &&
                            valueCheck.diam_mm === v.diam_mm &&
                            valueCheck.avg_wt === v.avg_wt &&
                            valueCheck.color === v.color &&
                            valueCheck.shade === v.shade &&
                            valueCheck.cut === v.cut &&
                            valueCheck.clarity === v.clarity &&
                            valueCheck.typeSelect === v.typeSelect &&
                            (valueCheck.updateCarat === v.updateCarat ||
                              valueCheck.updatePice === v.updatePice)
                              ? valueCheck
                              : null
                          )
                        )
                      }
                      // style={{ backgroundColor: "green" }}
                    >
                      <FaTrashAlt className="orderFilter-add-to-cart-btn-icon" />{" "}
                      Remove From Cart
                    </Button>
                  )}
                </div>
              ) : parseFloat(v.updateCarat) > 10 ? (
                <Button
                  className="w-100 text-white bg-dark"
                  type="link"
                  style={{ backgroundColor: "red" }}
                  onClick={() => handleSave(v, i)}
                  disabled
                >
                  <FaCartPlus className="orderFilter-add-to-cart-btn-icon" />{" "}
                  Add to cart
                </Button>
              ) : (
                <Button
                  className="w-100 text-white bg-dark"
                  type="link"
                  onClick={() => handleSave(v, i)}
                >
                  <FaCartPlus className="orderFilter-add-to-cart-btn-icon" />{" "}
                  Add to cart
                </Button>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="d-flex justify-content-center w-100">
          <Empty style={{ fontSize: "1.2rem" }} />
        </div>
      )}
    </div>
  );
};

export default DiamondCards;
